<div class="modal-container">
  <gallery [items]="data.images"
           [thumbs]=false
           [objectFit]="'contain'"
           [selectedIndex]="data.selectedIndex">
  </gallery>

  <div mat-dialog-actions class="action-buttons">
    <button mat-raised-button [mat-dialog-close]="">Zatvori</button>
  </div>
</div>
